import { useQuery } from "@tanstack/react-query";
import { getSakhasWithWadapatra } from "../services/sakhaService";

export const useFetchSakhasWithWadapatra = () => {
    return useQuery({
        queryKey: ['sakhas'],
        queryFn: getSakhasWithWadapatra
    });
}
